import type { CSSProperties } from "react";
import baseStyles from "./ResourcePage.module.css";
import cx from "classnames";

interface ResourcePageHeaderProps {
  title: string;
  showTileCount?: boolean;
  tileCount?: number;
  children?: React.ReactNode;
  showSectionLinks?: boolean;
  className?: string;
  showFiltersBelowHeader?: boolean;
  style?: CSSProperties;
}

const ResourcePageHeader = ({
  title,
  showTileCount = true,
  tileCount,
  children,
  className = "",
  style,
}: ResourcePageHeaderProps) => {
  return (
    <div className={cx(baseStyles.resourcePageHeader, className)} style={style}>
      <div className={baseStyles.resourceTitleGroup}>
        <h1 className={baseStyles.resourcePageTitle}>{title}</h1>
        {showTileCount && (
          <p className={baseStyles.resourceCount}>{tileCount} Resources</p>
        )}
      </div>
      <div className={baseStyles.resourcePageHeaderFilters}>{children}</div>
    </div>
  );
};

export default ResourcePageHeader;
